import Vue from "vue";


import Page_474432708679ff4c293da8a1f37cbf26 from "@/views/100_pab-report-sus-emails.vue";

import Page_6901ec01f59911c4c5fbb7bdfe22e925 from "@/views/200_be-a-hero.vue";

import Page_d357bde6ee36451fa325d5e1a9e5cf72 from "@/views/300_hello-from-sam.vue";

import Page_90548a503035ea7f2119d5501e44634a from "@/views/400_which-emails-are-sus.vue";

import Page_219b3a534f1e48298c9c119870e9b739 from "@/views/500_difference-between.vue";

import Page_e6b46c480d78f26f9b60cac7d5d0fbb8 from "@/views/600_introducing-the-pab.vue";

import Page_9c2f4b4525d2deca8d91ba994c0904f0 from "@/views/700_what-to-report.vue";

import Page_9931f01f9147da321d27405740574db2 from "@/views/800_when-to-use-pab.vue";

import Page_5b551ebcafb1b5607a38d1ae6765868b from "@/views/900_pab-in-action-m-outlook.vue";

import Page_863eae8023ef263a781018641378f8ef from "@/views/1000_stop-look-think-report.vue";

import Page_b85d680d34a6e47890faf9f7447fbec8 from "@/views/1100_quiz-intro.vue";

import Page_7491cef0adcdb89dfdd886c0ae9ea19c from "@/views/1200_quiz.vue";

import Page_dfdb55936e09b38c5d145969927e4144 from "@/views/1300_congratulations.vue";



import QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636 from "@/views/quiz/question-01.vue";


import BTB_INTRO from '@/views/BTB_INTRO.vue';
import BTB_OUTRO from '@/views/BTB_OUTRO.vue';


Vue.component("Page_474432708679ff4c293da8a1f37cbf26", Page_474432708679ff4c293da8a1f37cbf26);

Vue.component("Page_6901ec01f59911c4c5fbb7bdfe22e925", Page_6901ec01f59911c4c5fbb7bdfe22e925);

Vue.component("Page_d357bde6ee36451fa325d5e1a9e5cf72", Page_d357bde6ee36451fa325d5e1a9e5cf72);

Vue.component("Page_90548a503035ea7f2119d5501e44634a", Page_90548a503035ea7f2119d5501e44634a);

Vue.component("Page_219b3a534f1e48298c9c119870e9b739", Page_219b3a534f1e48298c9c119870e9b739);

Vue.component("Page_e6b46c480d78f26f9b60cac7d5d0fbb8", Page_e6b46c480d78f26f9b60cac7d5d0fbb8);

Vue.component("Page_9c2f4b4525d2deca8d91ba994c0904f0", Page_9c2f4b4525d2deca8d91ba994c0904f0);

Vue.component("Page_9931f01f9147da321d27405740574db2", Page_9931f01f9147da321d27405740574db2);

Vue.component("Page_5b551ebcafb1b5607a38d1ae6765868b", Page_5b551ebcafb1b5607a38d1ae6765868b);

Vue.component("Page_863eae8023ef263a781018641378f8ef", Page_863eae8023ef263a781018641378f8ef);

Vue.component("Page_b85d680d34a6e47890faf9f7447fbec8", Page_b85d680d34a6e47890faf9f7447fbec8);

Vue.component("Page_7491cef0adcdb89dfdd886c0ae9ea19c", Page_7491cef0adcdb89dfdd886c0ae9ea19c);

Vue.component("Page_dfdb55936e09b38c5d145969927e4144", Page_dfdb55936e09b38c5d145969927e4144);



Vue.component("QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636", QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636);


Vue.component('BTB_INTRO', BTB_INTRO);
Vue.component('BTB_OUTRO', BTB_OUTRO);
